import React from 'react';

interface DrawerScrollerProps {
  children?: React.ReactNode;
  totalHeight?: string | number;
  startPoint?: number;
}

const DrawerScroller: React.FunctionComponent<DrawerScrollerProps> = ({
  children,
  totalHeight = 0,
  startPoint = 0,
}) => {
  return (
    <div
      style={{
        width: '100%',
        position: 'relative',
        height: totalHeight,
      }}
    >
      <div
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          transform: `translateY(${startPoint}px)`,
        }}
      >
        {children}
      </div>
    </div>
  );
};

export default DrawerScroller;
